import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Phone, CalendarDays, ArrowRight, UserRound } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export const MeetVerwalterButton = () => {
  const navigate = useNavigate();
  const [ansprechpartner, setAnsprechpartner] = useState([]);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;
    fetch(`${API}/api/meet/info`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => (r.ok ? r.json() : null))
      .then(d => d && setAnsprechpartner(d.ansprechpartner || []))
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (ansprechpartner.length < 2) return;
    const t = setInterval(() => setIdx(i => (i + 1) % ansprechpartner.length), 6000);
    return () => clearInterval(t);
  }, [ansprechpartner.length]);

  const ma = ansprechpartner[idx];

  return (
    <div className="relative hidden md:block group">
      <button
        type="button"
        data-testid="meet-verwalter-button"
        onClick={() => navigate('/portal/kontakt-termine')}
        className="flex items-center gap-2.5 pl-1.5 pr-1.5 3xl:pr-4 rounded-full border border-brand-gold/40 bg-gradient-to-r from-brand-navy to-[#22456e] text-white shadow-sm group-hover:shadow-lg transition-shadow duration-300 py-1.5"
        title="Treffen Sie Ihren Verwalter"
      >
        <span className="relative flex-shrink-0 w-8 h-8 rounded-full ring-2 ring-brand-gold/70 overflow-hidden bg-gray-200 flex items-center justify-center">
          <UserRound className="w-5 h-5 text-gray-400" />
          {ma?.photo_url && (
            <img src={`${API}${ma.photo_url}`} alt="" className="absolute inset-0 w-full h-full object-cover" onError={(e) => e.currentTarget.remove()} />
          )}
        </span>
        <span className="hidden 3xl:inline text-[12px] font-semibold whitespace-nowrap">Treffen Sie Ihren Verwalter</span>
      </button>

      {/* Hover-Panel: klappt nach unten auf */}
      <div
        data-testid="meet-verwalter-hover-panel"
        className="absolute right-0 top-full pt-2 w-56 opacity-0 invisible -translate-y-1 group-hover:opacity-100 group-hover:visible group-hover:translate-y-0 transition-all duration-300 z-50"
      >
        <div
          onClick={() => navigate('/portal/kontakt-termine')}
          className="cursor-pointer rounded-2xl border border-brand-gold/40 bg-gradient-to-b from-brand-navy to-[#22456e] text-white shadow-xl px-4 py-3 space-y-2"
        >
          <p className="flex items-center gap-2 text-[11px] text-white/85"><Phone className="w-3.5 h-3.5 text-brand-gold flex-shrink-0" /> Telefonisch Mo–Fr 9–14 Uhr</p>
          <p className="flex items-center gap-2 text-[11px] text-white/85"><CalendarDays className="w-3.5 h-3.5 text-brand-gold flex-shrink-0" /> Termin im Büro oder vor Ort</p>
          <p className="flex items-center gap-1.5 text-[12px] font-semibold text-brand-gold pt-1 border-t border-white/15">Jetzt Kontakt aufnehmen <ArrowRight className="w-3.5 h-3.5" /></p>
        </div>
      </div>
    </div>
  );
};

export default MeetVerwalterButton;
